import Buttons from "./Buttons";
import Fields from "./Fields";
import Labels from "./Labels";
import Validations from "./Validations";

const ResguardosLang = {
  Buttons,
  Fields,
  Labels,
  Validations,
};

export default ResguardosLang;
